export default "__VITE_ASSET__CGZZEcHf__"